import React from 'react';
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Button,
  Portal,
  useColorModeValue,
} from '@chakra-ui/react';
import { ChevronDownIcon } from '@chakra-ui/icons';

const InterfaceSelect = ({
  value,
  options,
  onChange,
  disabled = false,
  width = '100%',
}) => {
  const inputBg = useColorModeValue('white', 'navy.600');
  const textColor = useColorModeValue('navy.700', 'white');
  const hoverBg = useColorModeValue('gray.200', 'navy.500');
  const focusBorderColor = useColorModeValue('navy.500', 'navy.300');

  const [selected, setSelected] = React.useState(value ?? null);

  React.useEffect(() => {
    setSelected(value);
  }, [value]);

  function getLabelByValue(options, selectedValue) {
    if (Array.isArray(options)) {
      const found = options.find(
        (opt) =>
          (typeof opt === 'object' && opt.value === selectedValue) ||
          opt === selectedValue,
      );
      if (typeof found === 'object' && found !== null) return found.label;
      if (typeof found === 'string') return found;
      return 'Select';
    } else {
      const entry = Object.entries(options).find(
        ([label, val]) => val === selectedValue,
      );
      return entry ? entry[0] : 'Select Value';
    }
  }

  const handleSelect = (val) => {
    setSelected(val);
    if (onChange) onChange(val);
  };

  return (
    <Menu isLazy closeOnSelect={!disabled} isOpen={disabled ? false : undefined}>
      <MenuButton
        as={Button}
        rightIcon={<ChevronDownIcon />}
        bg={inputBg}
        color={textColor}
        borderRadius="lg"
        border="2px"
        borderColor={useColorModeValue('gray.300', 'navy.600')}
        _hover={{ bg: hoverBg }}
        _focus={{
          outline: 'none',
          borderColor: focusBorderColor,
          boxShadow: `0 0 0 1px ${focusBorderColor}`,
        }}
        size="sm"
        width={width}
        textAlign="left"
        isDisabled={disabled}
      >
        {getLabelByValue(options, selected)}
      </MenuButton>

      {/* FIX */}
      <Portal>
        <MenuList
          borderRadius="lg"
          fontSize="14px"
          zIndex="9999"
          p="2"
          bg={inputBg}
          color={textColor}
          maxHeight="300px"
          overflowY="auto"
          minW="200px"
          boxShadow="lg"
        >
          {Array.isArray(options)
            ? options.map((opt, idx) =>
                typeof opt === 'object' ? (
                  <MenuItem
                    key={opt.value ?? idx}
                    onClick={() => handleSelect(opt.value)}
                    _hover={{ bg: hoverBg }}
                    fontWeight={500}
                    my={1}
                  >
                    {opt.label}
                  </MenuItem>
                ) : (
                  <MenuItem
                    key={opt}
                    onClick={() => handleSelect(opt)}
                    _hover={{ bg: hoverBg }}
                    fontWeight={500}
                    my={1}
                  >
                    {opt}
                  </MenuItem>
                ),
              )
            : Object.entries(options).map(([label, value]) => (
                <MenuItem
                  key={value}
                  onClick={() => handleSelect(value)}
                  _hover={{ bg: hoverBg }}
                  fontWeight={500}
                  my={1}
                >
                  {label}
                </MenuItem>
              ))}
        </MenuList>
      </Portal>
    </Menu>
  );
};

export default InterfaceSelect;